import React, { useState, useEffect, useRef } from "react";
import {
  FiClipboard,
  FiCalendar,
  FiUser,
  FiEdit3,
  FiPackage,
  FiHome,
  FiRefreshCw,
  FiPlus,
  FiEye,
  FiTrash2,
  FiSave,
  FiX,
  FiList,
  FiDollarSign,
  FiBarChart2,
  FiSearch,
  FiTrendingUp,
  FiTrendingDown,
  FiDownload,
  FiUpload,
} from "react-icons/fi";
import "./admin/Admin.css";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";

const KiemKe = () => {
  const [formData, setFormData] = useState({
    NgayKiemKe: new Date().toISOString().split("T")[0],
    TenUser: "",
    GhiChu: "",
  });

  const [inventory, setInventory] = useState([]);
  const [existingRecords, setExistingRecords] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [viewMode, setViewMode] = useState("create"); // 'create', 'list', 'view', 'edit'
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  // New state for store and date selection
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [isAdmin, setIsAdmin] = useState(false);
  const [detailedRecords, setDetailedRecords] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedRecordDetail, setSelectedRecordDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);

  // Add new state variables for categories and grouped data
  const [categories, setCategories] = useState({});
  const [groupedInventory, setGroupedInventory] = useState({});

  // Add new state for import functionality
  const [importMessage, setImportMessage] = useState("");
  const [importLoading, setImportLoading] = useState(false);

  // Define hidden categories
  const HIDDEN_CATEGORIES = [
    "0001",
    "0002",
    "0003",
    "0004",
    "0005",
    "0006",
    "0007",
    "0008",
    "0009",
    "0010",
    "0011",
    "0012",
    "0013",
    "NLBM",
  ];

  // Add new state for search and filters
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [stockFilter, setStockFilter] = useState(""); // 'negative', 'positive', 'zero', ''
  const [storeSearchTerm, setStoreSearchTerm] = useState("");
  const [isStoreDropdownOpen, setIsStoreDropdownOpen] = useState(false);
  const storeDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        storeDropdownRef.current &&
        !storeDropdownRef.current.contains(event.target)
      ) {
        setIsStoreDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const renderSelectionSection = () => {
    const filteredStores = stores.filter((store) =>
      store.TenCuaHang.toLowerCase().includes(storeSearchTerm.toLowerCase())
    );

    const selectedStoreName = selectedStore
      ? stores.find((s) => s.IDCH === selectedStore)?.TenCuaHang
      : "";

    return (
      <div className="content-section">
        <div className="card">
          <div className="card-header">
            <h5 className="mb-0">Chọn cửa hàng và ngày kiểm kê</h5>
          </div>
          <div className="card-body">
            <div className="row">
              {isAdmin && (
                <div className="col-md-6">
                  <label className="form-label">Cửa hàng:</label>
                  <div className="position-relative" ref={storeDropdownRef}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Gõ để tìm kiếm cửa hàng..."
                      value={
                        isStoreDropdownOpen
                          ? storeSearchTerm
                          : selectedStoreName
                      }
                      onChange={(e) => {
                        setStoreSearchTerm(e.target.value);
                        setIsStoreDropdownOpen(true);
                      }}
                      onFocus={() => {
                        setIsStoreDropdownOpen(true);
                        setStoreSearchTerm("");
                      }}
                      required
                      aria-label="Chọn cửa hàng"
                      autoComplete="off"
                    />
                    {isStoreDropdownOpen && (
                      <div
                        className="position-absolute w-100 bg-white border rounded shadow-sm"
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          zIndex: 1000,
                          top: "100%",
                          marginTop: "2px",
                        }}
                      >
                        {filteredStores.length > 0 ? (
                          filteredStores.map((store) => (
                            <div
                              key={store.IDCH}
                              className="px-3 py-2 cursor-pointer hover-bg-light"
                              style={{ cursor: "pointer" }}
                              onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#f8f9fa")
                              }
                              onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "white")
                              }
                              onClick={() => {
                                setSelectedStore(store.IDCH);
                                setStoreSearchTerm("");
                                setIsStoreDropdownOpen(false);
                              }}
                            >
                              {store.TenCuaHang}{" "}
                              <span className="text-muted">({store.IDCH})</span>
                            </div>
                          ))
                        ) : (
                          <div className="px-3 py-2 text-muted">
                            Không tìm thấy cửa hàng
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className={isAdmin ? "col-md-6" : "col-md-12"}>
                <label htmlFor="date-select" className="form-label">
                  Ngày kiểm kê:
                </label>
                <input
                  id="date-select"
                  type="date"
                  className="form-control"
                  value={selectedDate}
                  onChange={handleDateChange}
                  required
                  aria-label="Chọn ngày kiểm kê"
                />
              </div>
            </div>
            {selectedStore && selectedDate && (
              <div className="mt-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() =>
                    fetchInventoryData(selectedStore, selectedDate)
                  }
                  disabled={loading}
                >
                  <FiRefreshCw className={loading ? "spinning me-1" : "me-1"} />
                  {loading ? "Đang tải..." : "Tải dữ liệu tồn kho"}
                </button>
                <div className="small text-muted mt-2">
                  {selectedDate === new Date().toISOString().split("T")[0]
                    ? "Dữ liệu lấy từ tồn realtime."
                    : "Dữ liệu lấy theo thời điểm (as-of) ngày đã chọn."}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Fetch inventory data on component mount
  useEffect(() => {
    // Check admin status
    const adminFlag = localStorage.getItem("isAdmin");
    setIsAdmin(adminFlag === "true");

    // Get store information from localStorage
    const idch = localStorage.getItem("IDCH");
    const tenCuaHang = localStorage.getItem("TenCuaHang");

    if (adminFlag === "true") {
      fetchStores();
    }

    if (idch) {
      setSelectedStore(idch);
      fetchInventoryData(idch, selectedDate);
    } else {
      setMessage("Không tìm thấy thông tin cửa hàng. Vui lòng đăng nhập lại.");
    }

    fetchExistingRecords();
  }, []);

  // Fetch stores for admin
  const fetchStores = async () => {
    try {
      const response = await fetch("https://doticom.vn:3000/stores");
      if (response.ok) {
        const storesData = await response.json();
        setStores(storesData);
      }
    } catch (error) {
      console.error("Lỗi tải danh sách cửa hàng:", error);
    }
  };

  // Hàm gọi API lấy tên danh mục
  const fetchCategoryName = async (maNLSP) => {
    try {
      const response = await fetch(
        `https://doticom.vn:3000/categories/${maNLSP}`
      );
      if (response.ok) {
        const result = await response.json();
        if (result.length > 0) {
          return result[0].TenLoaiSP;
        }
      }
      return "Không xác định";
    } catch (err) {
      console.error(`Lỗi khi lấy tên danh mục cho ${maNLSP}:`, err);
      return "Không xác định";
    }
  };

  const fetchInventoryData = async (
    maCH = selectedStore,
    ngayNhap = selectedDate
  ) => {
    if (!maCH) {
      setMessage("Vui lòng chọn cửa hàng và ngày kiểm kê");
      return;
    }

    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        MaCH: String(maCH).trim(),
        NgayKiemKe: ngayNhap,
        includeZero: "1",
      });
      const response = await fetch(
        `https://doticom.vn:3000/api/pos-inventory/end-of-day?${queryParams}`
      );
      const result = await response.json();
      const data =
        result && result.success && result.data
          ? result.data
          : Array.isArray(result)
            ? result
            : [];

      if (data && data.length > 0) {
        // Transform end-of-day ledger data to inventory check format.
        const inventoryData = data
          .filter((item) => !item.MaNLSP || !HIDDEN_CATEGORIES.includes(item.MaNLSP))
          .map((item) => {
            const rawQty = item.Quantity ?? item.TonSoSach ?? 0;
            const tonSoSach = Number(rawQty || 0);
            const tonThucTe = tonSoSach < 0 ? 0 : tonSoSach;

            return {
              MaSP: item.MaSP,
              TenSP: item.Ten_SP || item.TenSP || "",
              DonViTinh: item.DVT_SP || item.DonViTinh || "Cái",
              DonGia: Number(item.GiaMua || item.DonGia || 0),
              TonSoSach: tonSoSach,
              TonThucTe: tonThucTe,
              ChenhLech: tonThucTe - tonSoSach,
              ThanhTienChenhLech: 0,
              MaNLSP: item.MaNLSP,
              UpdatedAt: item.UpdatedAt,
            };
          });

        setInventory(inventoryData);
        // Group inventory by category
        await groupInventoryByCategory(inventoryData);
        setMessage("");
      } else {
        setMessage("Không thể tải dữ liệu tồn kho hoặc không có dữ liệu");
        setInventory([]);
        setGroupedInventory({});
      }
    } catch (error) {
      setMessage("Lỗi khi tải dữ liệu: " + error.message);
      setInventory([]);
      setGroupedInventory({});
    } finally {
      setLoading(false);
    }
  };

  // Group inventory by category
  const groupInventoryByCategory = async (inventoryData) => {
    // Create object to store category names
    const categoryNames = {};
    // Group data by MaNLSP
    const grouped = {};

    // Filter out items from hidden categories first
    const filteredInventoryData = inventoryData.filter(
      (item) => !item.MaNLSP || !HIDDEN_CATEGORIES.includes(item.MaNLSP)
    );

    // Get unique MaNLSP values, excluding hidden categories
    const uniqueCategories = [
      ...new Set(
        filteredInventoryData
          .map((item) => item.MaNLSP)
          .filter((maNLSP) => maNLSP)
      ),
    ];

    // Fetch category names for all unique MaNLSP values
    await Promise.all(
      uniqueCategories.map(async (maNLSP) => {
        if (maNLSP) {
          const categoryName = await fetchCategoryName(maNLSP);
          categoryNames[maNLSP] = categoryName;

          // Initialize category group
          grouped[maNLSP] = {
            name: categoryName,
            items: filteredInventoryData.filter(
              (item) => item.MaNLSP === maNLSP
            ),
          };
        }
      })
    );

    // Handle items with no category (null or undefined MaNLSP) - exclude hidden ones
    const uncategorizedItems = filteredInventoryData.filter(
      (item) => !item.MaNLSP
    );
    if (uncategorizedItems.length > 0) {
      grouped["UNKNOWN"] = {
        name: "Chưa phân loại",
        items: uncategorizedItems,
      };
    }

    setCategories(categoryNames);
    setGroupedInventory(grouped);

    // Update inventory state to only include non-hidden items
    setInventory(filteredInventoryData);
  };

  // Update the fetchRecordDetails function to group by category
  const fetchRecordDetails = async (id) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://doticom.vn:3000/api/chi-tiet-phieu-kiem-ke/${id}`
      );
      if (response.ok) {
        const data = await response.json();
        const inventoryData = data.map((item) => ({
          ...item,
          ChenhLech: item.TonThucTe - item.TonSoSach,
          ThanhTienChenhLech: (item.TonThucTe - item.TonSoSach) * item.DonGia,
        }));

        setInventory(inventoryData);

        // Group the inventory data
        await groupInventoryByCategory(inventoryData);
      } else {
        setMessage("Không thể tải chi tiết phiếu kiểm kê");
      }
    } catch (error) {
      setMessage("Lỗi khi tải chi tiết: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch existing inventory check records
  const fetchExistingRecords = async () => {
    setLoading(true);
    try {
      const response = await fetch("https://doticom.vn:3000/api/phieu-kiem-ke");
      if (response.ok) {
        const data = await response.json();
        setExistingRecords(data);
      } else {
        setMessage("Không thể tải danh sách phiếu kiểm kê");
      }
    } catch (error) {
      setMessage("Lỗi khi tải danh sách: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch detailed records with chi tiet data
  const fetchDetailedRecords = async () => {
    setLoading(true);
    try {
      const response = await fetch("https://doticom.vn:3000/api/phieu-kiem-ke");
      if (response.ok) {
        const phieuData = await response.json();

        // Sort by date ascending
        const sortedPhieu = phieuData.sort(
          (a, b) => new Date(a.NgayKiemKe) - new Date(b.NgayKiemKe)
        );

        // Fetch details for each phieu
        const detailedData = await Promise.all(
          sortedPhieu.map(async (phieu) => {
            try {
              const detailResponse = await fetch(
                `https://doticom.vn:3000/api/chi-tiet-phieu-kiem-ke/${phieu.IDPhieu}`
              );
              if (detailResponse.ok) {
                const chiTiet = await detailResponse.json();
                return {
                  ...phieu,
                  ChiTiet: chiTiet.map((item) => ({
                    ...item,
                    ChenhLech: item.TonThucTe - item.TonSoSach,
                    ThanhTienChenhLech:
                      (item.TonThucTe - item.TonSoSach) * item.DonGia,
                  })),
                };
              } else {
                return { ...phieu, ChiTiet: [] };
              }
            } catch (error) {
              console.error(
                `Error fetching details for phieu ${phieu.IDPhieu}:`,
                error
              );
              return { ...phieu, ChiTiet: [] };
            }
          })
        );

        setDetailedRecords(detailedData);
      } else {
        setMessage("Không thể tải danh sách phiếu kiểm kê");
      }
    } catch (error) {
      setMessage("Lỗi khi tải danh sách: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Show detailed modal
  const showDetailedView = async (record) => {
    setDetailLoading(true);
    setSelectedRecordDetail(record);
    setShowDetailModal(true);

    try {
      if (!record.ChiTiet || record.ChiTiet.length === 0) {
        const detailResponse = await fetch(
          `https://doticom.vn:3000/api/chi-tiet-phieu-kiem-ke/${record.IDPhieu}`
        );
        if (detailResponse.ok) {
          const chiTiet = await detailResponse.json();
          const detailData = chiTiet.map((item) => ({
            ...item,
            ChenhLech: item.TonThucTe - item.TonSoSach,
            ThanhTienChenhLech: (item.TonThucTe - item.TonSoSach) * item.DonGia,
          }));

          // Group the detail data by category
          const groupedDetail = {};

          // Function to get category for each item
          const getCategoryForItems = async () => {
            // Get unique MaNLSP values
            const uniqueCategories = [
              ...new Set(
                detailData.filter((i) => i.MaNLSP).map((i) => i.MaNLSP)
              ),
            ];

            // Fetch category names for all unique MaNLSP values
            const categoryNames = {};
            await Promise.all(
              uniqueCategories.map(async (maNLSP) => {
                if (maNLSP) {
                  const categoryName = await fetchCategoryName(maNLSP);
                  categoryNames[maNLSP] = categoryName;

                  // Initialize category group
                  groupedDetail[maNLSP] = {
                    name: categoryName,
                    items: detailData.filter((item) => item.MaNLSP === maNLSP),
                  };
                }
              })
            );

            // Handle items with no category
            const uncategorizedItems = detailData.filter(
              (item) => !item.MaNLSP
            );
            if (uncategorizedItems.length > 0) {
              groupedDetail["UNKNOWN"] = {
                name: "Chưa phân loại",
                items: uncategorizedItems,
              };
            }

            setSelectedRecordDetail({
              ...record,
              ChiTiet: detailData,
              GroupedChiTiet: groupedDetail,
            });
          };

          await getCategoryForItems();
        }
      }
    } catch (error) {
      console.error("Error loading details:", error);
    } finally {
      setDetailLoading(false);
    }
  };

  // Export detailed inventory check to Excel
  const exportDetailedKiemKeExcel = async () => {
    if (detailedRecords.length === 0) {
      alert("Không có dữ liệu phiếu kiểm kê để xuất báo cáo");
      return;
    }

    const workbook = new ExcelJS.Workbook();

    // Create summary worksheet
    const summaryWS = workbook.addWorksheet("Tổng hợp phiếu kiểm kê");

    // Summary worksheet setup
    summaryWS.columns = [
      { header: "ID Phiếu", key: "IDPhieu", width: 12 },
      { header: "Ngày kiểm kê", key: "NgayKiemKe", width: 15 },
      { header: "Người kiểm kê", key: "TenUser", width: 20 },
      { header: "Ghi chú", key: "GhiChu", width: 30 },
      { header: "Tổng mặt hàng", key: "TongMatHang", width: 15 },
      { header: "Tổng chênh lệch SL", key: "TongChenhLechSL", width: 18 },
      { header: "Giá trị chênh lệch", key: "GiaTriChenhLech", width: 20 },
    ];

    // Add title
    summaryWS.mergeCells("A1:G1");
    const titleCell = summaryWS.getCell("A1");
    titleCell.value = "BÁO CÁO CHI TIẾT PHIẾU KIỂM KÊ";
    titleCell.font = { size: 16, bold: true };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };

    summaryWS.mergeCells("A2:G2");
    const dateCell = summaryWS.getCell("A2");
    dateCell.value = `Ngày xuất: ${new Date().toLocaleDateString("vi-VN")}`;
    dateCell.font = { size: 12, italic: true };
    dateCell.alignment = { horizontal: "center", vertical: "middle" };

    summaryWS.addRow([]);

    // Header row
    const headerRow = summaryWS.addRow([
      "ID Phiếu",
      "Ngày kiểm kê",
      "Người kiểm kê",
      "Ghi chú",
      "Tổng mặt hàng",
      "Tổng chênh lệch SL",
      "Giá trị chênh lệch",
    ]);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center" };
    headerRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE6E6FA" },
    };

    let grandTotalItems = 0;
    let grandTotalValueDifference = 0;

    // Add summary data and create detail worksheets
    for (const phieu of detailedRecords) {
      const chiTiet = phieu.ChiTiet || [];
      const tongMatHang = chiTiet.length;
      let tongChenhLechSL = 0;
      let giaTriChenhLech = 0;

      chiTiet.forEach((item) => {
        tongChenhLechSL += Math.abs(item.ChenhLech || 0);
        giaTriChenhLech += Math.abs(item.ThanhTienChenhLech || 0);
      });

      // Add summary row
      const dataRow = summaryWS.addRow([
        `#${phieu.IDPhieu}`,
        new Date(phieu.NgayKiemKe).toLocaleDateString("vi-VN"),
        phieu.TenUser,
        phieu.GhiChu || "-",
        tongMatHang,
        tongChenhLechSL,
        giaTriChenhLech,
      ]);

      // Format numbers
      dataRow.getCell(5).numFmt = "#,##0";
      dataRow.getCell(6).numFmt = "#,##0.00";
      dataRow.getCell(7).numFmt = "#,##0";

      grandTotalItems += tongMatHang;
      grandTotalValueDifference += giaTriChenhLech;

      // Create detailed worksheet for each phieu
      if (chiTiet.length > 0) {
        const detailWS = workbook.addWorksheet(`Chi tiết #${phieu.IDPhieu}`);

        // Setup columns
        detailWS.columns = [
          { header: "STT", key: "STT", width: 8 },
          { header: "Mã SP", key: "MaSP", width: 15 },
          { header: "Tên sản phẩm", key: "TenSP", width: 35 },
          { header: "ĐVT", key: "DonViTinh", width: 10 },
          { header: "Đơn giá", key: "DonGia", width: 15 },
          { header: "Tồn sổ sách", key: "TonSoSach", width: 15 },
          { header: "Tồn thực tế", key: "TonThucTe", width: 15 },
          { header: "Chênh lệch", key: "ChenhLech", width: 15 },
          { header: "Thành tiền CL", key: "ThanhTienCL", width: 18 },
        ];

        // Title
        detailWS.mergeCells("A1:I1");
        const detailTitle = detailWS.getCell("A1");
        detailTitle.value = `CHI TIẾT PHIẾU KIỂM KÊ #${phieu.IDPhieu}`;
        detailTitle.font = { size: 14, bold: true };
        detailTitle.alignment = { horizontal: "center" };

        detailWS.mergeCells("A2:I2");
        const detailInfo = detailWS.getCell("A2");
        detailInfo.value = `Ngày: ${new Date(
          phieu.NgayKiemKe
        ).toLocaleDateString("vi-VN")} | Người kiểm kê: ${phieu.TenUser}`;
        detailInfo.font = { italic: true };
        detailInfo.alignment = { horizontal: "center" };

        if (phieu.GhiChu) {
          detailWS.mergeCells("A3:I3");
          const noteInfo = detailWS.getCell("A3");
          noteInfo.value = `Ghi chú: ${phieu.GhiChu}`;
          noteInfo.font = { italic: true };
          noteInfo.alignment = { horizontal: "left" };
        }

        detailWS.addRow([]);

        // Header
        const detailHeaderRow = detailWS.addRow([
          "STT",
          "Mã SP",
          "Tên sản phẩm",
          "ĐVT",
          "Đơn giá",
          "Tồn sổ sách",
          "Tồn thực tế",
          "Chênh lệch",
          "Thành tiền CL",
        ]);
        detailHeaderRow.font = { bold: true };
        detailHeaderRow.alignment = { horizontal: "center" };
        detailHeaderRow.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFDDEEFF" },
        };

        // Detail data
        chiTiet.forEach((item, index) => {
          const row = detailWS.addRow([
            index + 1,
            item.MaSP,
            item.TenSP,
            item.DonViTinh,
            item.DonGia,
            item.TonSoSach,
            item.TonThucTe,
            item.ChenhLech || 0,
            item.ThanhTienChenhLech || 0,
          ]);

          // Format numbers
          row.getCell(5).numFmt = "#,##0";
          row.getCell(6).numFmt = "#,##0";
          row.getCell(7).numFmt = "#,##0";
          row.getCell(8).numFmt = "#,##0";
          row.getCell(9).numFmt = "#,##0";

          // Color coding for differences
          const chenhLech = item.ChenhLech || 0;
          if (chenhLech > 0) {
            row.getCell(8).font = { color: { argb: "FF10B981" }, bold: true };
            row.getCell(9).font = { color: { argb: "FF10B981" }, bold: true };
          } else if (chenhLech < 0) {
            row.getCell(8).font = { color: { argb: "FFEF4444" }, bold: true };
            row.getCell(9).font = { color: { argb: "FFEF4444" }, bold: true };
          }
        });

        // Total row for detail
        const detailTotalRow = detailWS.addRow([
          "",
          "",
          "TỔNG CỘNG",
          "",
          "",
          chiTiet.reduce((sum, item) => sum + item.TonSoSach, 0),
          chiTiet.reduce((sum, item) => sum + item.TonThucTe, 0),
          chiTiet.reduce((sum, item) => sum + Math.abs(item.ChenhLech || 0), 0),
          chiTiet.reduce(
            (sum, item) => sum + Math.abs(item.ThanhTienChenhLech || 0),
            0
          ),
        ]);
        detailTotalRow.font = { bold: true };
        detailTotalRow.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFCCCC" },
        };

        // Format total row numbers
        detailTotalRow.getCell(6).numFmt = "#,##0";
        detailTotalRow.getCell(7).numFmt = "#,##0";
        detailTotalRow.getCell(8).numFmt = "#,##0";
        detailTotalRow.getCell(9).numFmt = "#,##0";
      }
    }

    // Add grand total to summary
    const totalRow = summaryWS.addRow([
      "",
      "TỔNG CỘNG",
      "",
      "",
      grandTotalItems,
      "",
      grandTotalValueDifference,
    ]);
    totalRow.font = { bold: true };
    totalRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFD700" },
    };

    // Export file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `PhieuKiemKe_ChiTiet_${new Date().toISOString().split("T")[0]
      }.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleFormChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleActualStockInputWheel = (event) => {
    event.currentTarget.blur();
  };

  const handleActualStockInputKeyDown = (event) => {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
    }
  };

  const buildInventoryItemWithActualStock = (item, tonThucTe) => {
    const numericValue = Number(tonThucTe);
    const safeValue = Number.isFinite(numericValue) ? numericValue : 0;
    const tonSoSach = Number(item.TonSoSach || 0);
    const donGia = Number(item.DonGia || 0);
    const chenhLech = safeValue - tonSoSach;

    return {
      ...item,
      TonThucTe: safeValue,
      ChenhLech: chenhLech,
      ThanhTienChenhLech: chenhLech * donGia,
    };
  };

  const handleQuantityChange = (productCode, tonThucTe) => {
    const normalizeProductCode = (value) =>
      String(value ?? "").trim().toUpperCase();
    const normalizedCode = normalizeProductCode(productCode);

    setInventory((prev) =>
      prev.map((item) => {
        if (normalizeProductCode(item.MaSP) !== normalizedCode) {
          return item;
        }

        return buildInventoryItemWithActualStock(item, tonThucTe);
      })
    );

    setGroupedInventory((prev) => {
      if (!prev || Object.keys(prev).length === 0) {
        return prev;
      }

      const next = {};
      Object.entries(prev).forEach(([categoryId, group]) => {
        next[categoryId] = {
          ...group,
          items: group.items.map((item) => {
            if (normalizeProductCode(item.MaSP) !== normalizedCode) {
              return item;
            }

            return buildInventoryItemWithActualStock(item, tonThucTe);
          }),
        };
      });

      return next;
    });
  };

  const handleSetAllActualStockZero = () => {
    setInventory((prev) =>
      prev.map((item) => buildInventoryItemWithActualStock(item, 0))
    );

    setGroupedInventory((prev) => {
      if (!prev || Object.keys(prev).length === 0) {
        return prev;
      }

      const next = {};
      Object.entries(prev).forEach(([categoryId, group]) => {
        next[categoryId] = {
          ...group,
          items: group.items.map((item) =>
            buildInventoryItemWithActualStock(item, 0)
          ),
        };
      });

      return next;
    });

    setMessage("Cập nhật tồn thực tế toàn bộ sản phẩm thành 0 thành công!");
  };

  const calculateTotals = () => {
    return inventory.reduce(
      (totals, item) => {
        totals.totalDifference += Math.abs(item.ChenhLech);
        totals.totalAmount += Math.abs(item.ThanhTienChenhLech);
        return totals;
      },
      { totalDifference: 0, totalAmount: 0 }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.TenUser.trim()) {
      setMessage("Vui lòng nhập tên người kiểm kê");
      return;
    }

    if (
      !selectedStore ||
      (typeof selectedStore === "string" && selectedStore.trim() === "") ||
      selectedStore === ""
    ) {
      setMessage("Vui lòng chọn cửa hàng trước khi lưu kiểm kê");
      return;
    }

    if (!inventory.length) {
      setMessage("Chưa có dữ liệu kiểm kê để lưu");
      return;
    }

    if (inventory.some((item) => !String(item.MaSP || "").trim())) {
      setMessage("Có dòng thiếu mã sản phẩm, vui lòng kiểm tra lại");
      return;
    }

    setSubmitting(true);
    setMessage("");

    try {
      const submitData = {
        MaCH: Number(selectedStore),
        NgayKiemKe: formData.NgayKiemKe || selectedDate,
        TenUser: formData.TenUser,
        GhiChu: formData.GhiChu,
        ChiTiet: inventory.map((item) => ({
          MaSP: item.MaSP,
          TenSP: String(item.TenSP || ""),
          DonViTinh: item.DonViTinh,
          DonGia: Number(item.DonGia || 0),
          TonSoSach: Number(item.TonSoSach || 0),
          TonThucTe: Number(item.TonThucTe || 0),
        })),
      };

      const response = await fetch(
        "https://doticom.vn:3000/api/phieu-kiem-ke",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(submitData),
        }
      );

      if (response.ok) {
        const result = await response.json();
        if (result?.inventoryAdjusted) {
          setMessage(
            `Tạo phiếu kiểm kê thành công. Đã điều chỉnh ${result.adjustedCount || 0} mặt hàng.`
          );
        } else {
          setMessage("Lưu phiếu kiểm kê thành công!");
        }

        setFormData({
          NgayKiemKe: selectedDate,
          TenUser: "",
          GhiChu: "",
        });
        fetchInventoryData(selectedStore, selectedDate);
      } else {
        const errorData = await response.json();
        setMessage(
          "Lỗi: " + (errorData.message || "Không thể lưu phiếu kiểm kê")
        );
      }
    } catch (error) {
      console.error("Submit error:", error);
      setMessage("Lỗi kết nối: " + error.message);
    } finally {
      setSubmitting(false);
    }
  };

  // Update record
  const updateRecord = async () => {
    if (!formData.TenUser.trim()) {
      setMessage("Vui lòng nhập tên người kiểm kê");
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch(
        `https://doticom.vn:3000/api/phieu-kiem-ke/${selectedRecord.IDPhieu}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setMessage("Cập nhật phiếu kiểm kê thành công!");
        setViewMode("list");
        fetchExistingRecords();
      } else {
        const errorData = await response.json();
        setMessage("Lỗi: " + errorData.message);
      }
    } catch (error) {
      setMessage("Lỗi kết nối: " + error.message);
    } finally {
      setSubmitting(false);
    }
  };

  // Delete record
  const deleteRecord = async (id) => {
    if (!window.confirm("Bạn có chắc chắn muốn xóa phiếu kiểm kê này?")) {
      return;
    }

    try {
      const response = await fetch(
        `https://doticom.vn:3000/api/phieu-kiem-ke/${id}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        setMessage("Xóa phiếu kiểm kê thành công!");
        fetchExistingRecords();
      } else {
        const errorData = await response.json();
        setMessage("Lỗi: " + errorData.message);
      }
    } catch (error) {
      setMessage("Lỗi kết nối: " + error.message);
    }
  };

  // Handle view record
  const handleViewRecord = (record) => {
    setSelectedRecord(record);
    setFormData({
      NgayKiemKe: new Date(record.NgayKiemKe).toISOString().split("T")[0],
      TenUser: record.TenUser,
      GhiChu: record.GhiChu || "",
    });
    fetchRecordDetails(record.IDPhieu);
    setViewMode("view");
  };

  // Handle edit record
  const handleEditRecord = (record) => {
    setSelectedRecord(record);
    setFormData({
      NgayKiemKe: new Date(record.NgayKiemKe).toISOString().split("T")[0],
      TenUser: record.TenUser,
      GhiChu: record.GhiChu || "",
    });
    fetchRecordDetails(record.IDPhieu);
    setViewMode("edit");
  };

  // Switch to list view
  const showListView = () => {
    setViewMode("list");
    fetchExistingRecords();
    setMessage("");
  };

  // Switch to create view
  const showCreateView = () => {
    const today = new Date().toISOString().split("T")[0];
    setViewMode("create");
    setFormData({
      NgayKiemKe: today,
      TenUser: "",
      GhiChu: "",
    });
    setSelectedDate(today);
    fetchInventoryData();
    setMessage("");
  };

  // Filter inventory based on search term and filters
  const filterInventory = (inventoryData) => {
    let filtered = [...inventoryData];

    // Apply search filter
    if (searchTerm.trim()) {
      const searchLower = searchTerm.toLowerCase().trim();
      filtered = filtered.filter(
        (item) =>
          item.MaSP.toLowerCase().includes(searchLower) ||
          item.TenSP.toLowerCase().includes(searchLower)
      );
    }

    // Apply category filter
    if (selectedCategory) {
      filtered = filtered.filter((item) => item.MaNLSP === selectedCategory);
    }

    // Apply stock filter
    if (stockFilter === "negative") {
      filtered = filtered.filter((item) => item.TonSoSach < 0);
    } else if (stockFilter === "positive") {
      filtered = filtered.filter((item) => item.TonSoSach > 0);
    } else if (stockFilter === "zero") {
      filtered = filtered.filter((item) => item.TonSoSach === 0);
    }

    return filtered;
  };

  // Get filtered and grouped inventory
  const getFilteredGroupedInventory = () => {
    const filteredInventory = filterInventory(inventory);

    if (Object.keys(groupedInventory).length === 0) {
      return { filteredInventory, filteredGrouped: {} };
    }

    // Re-group the filtered inventory
    const filteredGrouped = {};

    for (const categoryId in groupedInventory) {
      const group = groupedInventory[categoryId];
      const filteredItems = group.items.filter((item) =>
        filteredInventory.some((filtered) => filtered.MaSP === item.MaSP)
      );

      if (filteredItems.length > 0) {
        filteredGrouped[categoryId] = {
          ...group,
          items: filteredItems,
        };
      }
    }

    return { filteredInventory, filteredGrouped };
  };

  // Get available categories for filter dropdown
  const getAvailableCategories = () => {
    const categoryMap = {};

    inventory.forEach((item) => {
      if (item.MaNLSP && !HIDDEN_CATEGORIES.includes(item.MaNLSP)) {
        const categoryName = categories[item.MaNLSP] || "Không xác định";
        categoryMap[item.MaNLSP] = categoryName;
      }
    });

    return categoryMap;
  };

  // Reset filters
  const resetFilters = () => {
    setSearchTerm("");
    setSelectedCategory("");
    setStockFilter("");
  };

  const renderListView = () => (
    <div className="admin-layout">
      <div className="admin-main" style={{ marginLeft: 0 }}>
        <header className="admin-header">
          <div className="header-left">
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <FiClipboard size={32} color="#495057" aria-hidden="true" />
              <div>
                <h1>Danh sách phiếu kiểm kê</h1>
                <p>Quản lý và xem các phiếu kiểm kê đã tạo</p>
              </div>
            </div>
          </div>
          <div className="header-right">
            <button
              type="button"
              className="btn btn-outline-success me-2"
              onClick={() => {
                fetchDetailedRecords();
                exportDetailedKiemKeExcel();
              }}
              disabled={loading}
              aria-label="Xuất báo cáo Excel chi tiết"
              title="Xuất báo cáo Excel chi tiết tất cả phiếu kiểm kê"
            >
              <FiDownload className="me-1" aria-hidden="true" />
              Xuất Excel chi tiết
            </button>
            <button
              type="button"
              className="btn btn-outline-primary me-2"
              onClick={fetchExistingRecords}
              disabled={loading}
              aria-label={
                loading
                  ? "Đang làm mới dữ liệu"
                  : "Làm mới danh sách phiếu kiểm kê"
              }
              title={
                loading
                  ? "Đang làm mới dữ liệu"
                  : "Làm mới danh sách phiếu kiểm kê"
              }
            >
              <FiRefreshCw
                className={loading ? "spinning" : ""}
                aria-hidden="true"
              />
              {loading ? "Đang tải..." : "Làm mới"}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={showCreateView}
              aria-label="Tạo phiếu kiểm kê mới"
              title="Tạo phiếu kiểm kê mới"
            >
              <FiPlus className="me-1" aria-hidden="true" />
              Tạo phiếu mới
            </button>
          </div>
        </header>

        <div className="content-section">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <div
                    className="spinner-border"
                    role="status"
                    aria-label="Đang tải danh sách phiếu kiểm kê"
                  >
                    <span className="sr-only">Đang tải...</span>
                  </div>
                </div>
              ) : (
                <div className="table-responsive">
                  <table
                    className="table table-striped"
                    role="table"
                    aria-label="Danh sách phiếu kiểm kê"
                  >
                    <caption className="sr-only">
                      Bảng danh sách {existingRecords.length} phiếu kiểm kê với
                      thông tin chi tiết
                    </caption>
                    <thead>
                      <tr role="row">
                        <th scope="col">ID Phiếu</th>
                        <th scope="col">Ngày kiểm kê</th>
                        <th scope="col">Người kiểm kê</th>
                        <th scope="col">Ghi chú</th>
                        <th scope="col">Thao tác</th>
                      </tr>
                    </thead>
                    <tbody>
                      {existingRecords.map((record) => (
                        <tr key={record.IDPhieu} role="row">
                          <td>#{record.IDPhieu}</td>
                          <td>
                            {new Date(record.NgayKiemKe).toLocaleDateString(
                              "vi-VN"
                            )}
                          </td>
                          <td>{record.TenUser}</td>
                          <td>{record.GhiChu || "-"}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-outline-info btn-sm me-2"
                              onClick={() => showDetailedView(record)}
                              aria-label={`Xem chi tiết phiếu kiểm kê số ${record.IDPhieu}`}
                              title={`Xem chi tiết phiếu kiểm kê số ${record.IDPhieu}`}
                            >
                              <FiEye className="me-1" aria-hidden="true" />
                              Chi tiết
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm me-2"
                              onClick={() => handleEditRecord(record)}
                              aria-label={`Chỉnh sửa phiếu kiểm kê số ${record.IDPhieu}`}
                              title={`Chỉnh sửa phiếu kiểm kê số ${record.IDPhieu}`}
                            >
                              <FiEdit3 className="me-1" aria-hidden="true" />
                              Sửa
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => deleteRecord(record.IDPhieu)}
                              aria-label={`Xóa phiếu kiểm kê số ${record.IDPhieu}`}
                              title={`Xóa phiếu kiểm kê số ${record.IDPhieu}`}
                            >
                              <FiTrash2 className="me-1" aria-hidden="true" />
                              Xóa
                            </button>
                          </td>
                        </tr>
                      ))}
                      {existingRecords.length === 0 && (
                        <tr role="row">
                          <td
                            colSpan="5"
                            style={{
                              textAlign: "center",
                              padding: "40px",
                              color: "#6c757d",
                            }}
                          >
                            Chưa có phiếu kiểm kê nào
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Detail Modal */}
        {showDetailModal && (
          <div
            className="modal"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            role="dialog"
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
            aria-modal="true"
          >
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 id="modal-title" className="modal-title">
                    Chi tiết phiếu kiểm kê #{selectedRecordDetail?.IDPhieu}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDetailModal(false)}
                    aria-label="Đóng hộp thoại chi tiết"
                    title="Đóng hộp thoại"
                  ></button>
                </div>
                <div className="modal-body" id="modal-description">
                  {detailLoading ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                      <div className="spinner-border" role="status">
                        <span className="sr-only">Đang tải...</span>
                      </div>
                    </div>
                  ) : selectedRecordDetail ? (
                    <>
                      <div className="row mb-3">
                        <div className="col-md-3">
                          <strong>Ngày kiểm kê:</strong>
                          <br />
                          {new Date(
                            selectedRecordDetail.NgayKiemKe
                          ).toLocaleDateString("vi-VN")}
                        </div>
                        <div className="col-md-3">
                          <strong>Người kiểm kê:</strong>
                          <br />
                          {selectedRecordDetail.TenUser}
                        </div>
                        <div className="col-md-6">
                          <strong>Ghi chú:</strong>
                          <br />
                          {selectedRecordDetail.GhiChu || "Không có"}
                        </div>
                      </div>

                      {selectedRecordDetail.ChiTiet &&
                        selectedRecordDetail.ChiTiet.length > 0 ? (
                        <div>
                          {selectedRecordDetail.GroupedChiTiet ? (
                            // Render grouped details
                            Object.keys(
                              selectedRecordDetail.GroupedChiTiet
                            ).map((categoryId) => {
                              const group =
                                selectedRecordDetail.GroupedChiTiet[categoryId];
                              return (
                                <div
                                  key={categoryId}
                                  className="category-group mb-4"
                                >
                                  <h5
                                    className="category-header"
                                    style={{
                                      backgroundColor: "#f8f9fa",
                                      padding: "10px 15px",
                                      borderRadius: "5px",
                                      marginBottom: "10px",
                                      fontWeight: "600",
                                      color: "#495057",
                                      borderLeft: "5px solid #007bff",
                                    }}
                                  >
                                    {group.name}
                                    <span
                                      className="badge bg-secondary ms-2"
                                      style={{
                                        fontSize: "0.7rem",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {group.items.length} sản phẩm
                                    </span>
                                  </h5>

                                  <div className="table-responsive">
                                    <table className="table table-striped table-sm">
                                      <thead>
                                        <tr>
                                          <th>STT</th>
                                          <th>Mã SP</th>
                                          <th>Tên sản phẩm</th>
                                          <th style={{ textAlign: "center" }}>
                                            ĐVT
                                          </th>
                                          <th style={{ textAlign: "right" }}>
                                            Đơn giá
                                          </th>
                                          <th style={{ textAlign: "right" }}>
                                            Tồn sổ sách
                                          </th>
                                          <th style={{ textAlign: "right" }}>
                                            Tồn thực tế
                                          </th>
                                          <th style={{ textAlign: "right" }}>
                                            Chênh lệch
                                          </th>
                                          <th style={{ textAlign: "right" }}>
                                            Thành tiền CL
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {group.items.map((item, idx) => (
                                          <tr key={item.IDChiTiet || idx}>
                                            <td>{idx + 1}</td>
                                            <td>
                                              <strong>{item.MaSP}</strong>
                                            </td>
                                            <td>{item.TenSP}</td>
                                            <td style={{ textAlign: "center" }}>
                                              {item.DonViTinh}
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                              {item.DonGia.toLocaleString(
                                                "vi-VN"
                                              )}{" "}
                                              ₫
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "right",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {item.TonSoSach}
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "right",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {item.TonThucTe}
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "right",
                                                color:
                                                  (item.ChenhLech || 0) > 0
                                                    ? "#10b981"
                                                    : (item.ChenhLech || 0) < 0
                                                      ? "#ef4444"
                                                      : "#6b7280",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {(item.ChenhLech || 0) > 0
                                                ? "+"
                                                : ""}
                                              {item.ChenhLech || 0}
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "right",
                                                color:
                                                  (item.ThanhTienChenhLech ||
                                                    0) > 0
                                                    ? "#10b981"
                                                    : (item.ThanhTienChenhLech ||
                                                      0) < 0
                                                      ? "#ef4444"
                                                      : "#6b7280",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {(item.ThanhTienChenhLech || 0) >
                                                0
                                                ? "+"
                                                : ""}
                                              {(
                                                item.ThanhTienChenhLech || 0
                                              ).toLocaleString("vi-VN")}{" "}
                                              ₫
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                      <tfoot>
                                        <tr
                                          style={{
                                            backgroundColor: "#f0f8ff",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          <td
                                            colSpan="5"
                                            style={{ textAlign: "right" }}
                                          >
                                            Tổng nhóm {group.name}:
                                          </td>
                                          <td style={{ textAlign: "right" }}>
                                            {group.items
                                              .reduce(
                                                (sum, item) =>
                                                  sum + (item.TonSoSach || 0),
                                                0
                                              )
                                              .toLocaleString("vi-VN")}
                                          </td>
                                          <td style={{ textAlign: "right" }}>
                                            {group.items
                                              .reduce(
                                                (sum, item) =>
                                                  sum + (item.TonThucTe || 0),
                                                0
                                              )
                                              .toLocaleString("vi-VN")}
                                          </td>
                                          <td style={{ textAlign: "right" }}>
                                            {group.items
                                              .reduce(
                                                (sum, item) =>
                                                  sum +
                                                  Math.abs(item.ChenhLech || 0),
                                                0
                                              )
                                              .toFixed(2)}
                                          </td>
                                          <td style={{ textAlign: "right" }}>
                                            {group.items
                                              .reduce(
                                                (sum, item) =>
                                                  sum +
                                                  Math.abs(
                                                    item.ThanhTienChenhLech || 0
                                                  ),
                                                0
                                              )
                                              .toLocaleString("vi-VN")}{" "}
                                            ₫
                                          </td>
                                        </tr>
                                      </tfoot>
                                    </table>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            // Render ungrouped details as fallback
                            <div className="table-responsive">
                              <table className="table table-striped table-sm">
                                <thead>
                                  <tr>
                                    <th>STT</th>
                                    <th>Mã SP</th>
                                    <th>Tên sản phẩm</th>
                                    <th style={{ textAlign: "center" }}>ĐVT</th>
                                    <th style={{ textAlign: "right" }}>Đơn giá</th>
                                    <th style={{ textAlign: "right" }}>
                                      Tồn sổ sách
                                    </th>
                                    <th style={{ textAlign: "right" }}>
                                      Tồn thực tế
                                    </th>
                                    <th style={{ textAlign: "right" }}>
                                      Chênh lệch
                                    </th>
                                    <th style={{ textAlign: "right" }}>
                                      Thành tiền CL
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {selectedRecordDetail.ChiTiet.map(
                                    (item, index) => (
                                      <tr key={item.IDChiTiet || index}>
                                        <td>{index + 1}</td>
                                        <td>
                                          <strong>{item.MaSP}</strong>
                                        </td>
                                        <td>{item.TenSP}</td>
                                        <td style={{ textAlign: "center" }}>
                                          {item.DonViTinh}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {item.DonGia.toLocaleString("vi-VN")} ₫
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "right",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {item.TonSoSach}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "right",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {item.TonThucTe}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "right",
                                            color:
                                              (item.ChenhLech || 0) > 0
                                                ? "#10b981"
                                                : (item.ChenhLech || 0) < 0
                                                  ? "#ef4444"
                                                  : "#6b7280",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {(item.ChenhLech || 0) > 0 ? "+" : ""}
                                          {item.ChenhLech || 0}
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "right",
                                            color:
                                              (item.ThanhTienChenhLech || 0) > 0
                                                ? "#10b981"
                                                : (item.ThanhTienChenhLech || 0) < 0
                                                  ? "#ef4444"
                                                  : "#6b7280",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {(item.ThanhTienChenhLech || 0) > 0
                                            ? "+"
                                            : ""}
                                          {(
                                            item.ThanhTienChenhLech || 0
                                          ).toLocaleString("vi-VN")}{" "}
                                          ₫
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                                <tfoot>
                                  <tr
                                    style={{
                                      backgroundColor: "#f8f9fa",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <td
                                      colSpan="7"
                                      style={{ textAlign: "right" }}
                                    >
                                      Tổng cộng:
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {selectedRecordDetail.ChiTiet.reduce(
                                        (sum, item) =>
                                          sum + Math.abs(item.ChenhLech || 0),
                                        0
                                      ).toFixed(2)}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {selectedRecordDetail.ChiTiet.reduce(
                                        (sum, item) =>
                                          sum +
                                          Math.abs(item.ThanhTienChenhLech || 0),
                                        0
                                      ).toLocaleString("vi-VN")}{" "}
                                      ₫
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          )}

                          {/* Grand total */}
                          <table className="table">
                            <tfoot>
                              <tr
                                style={{
                                  backgroundColor: "#f8f9fa",
                                  fontWeight: "bold",
                                }}
                              >
                                <td colSpan="7" style={{ textAlign: "right" }}>
                                  TỔNG CỘNG TẤT CẢ:
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {selectedRecordDetail.ChiTiet.reduce(
                                    (sum, item) =>
                                      sum + Math.abs(item.ChenhLech || 0),
                                    0
                                  ).toFixed(2)}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {selectedRecordDetail.ChiTiet.reduce(
                                    (sum, item) =>
                                      sum +
                                      Math.abs(item.ThanhTienChenhLech || 0),
                                    0
                                  ).toLocaleString("vi-VN")}{" "}
                                  ₫
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      ) : (
                        <div
                          style={{
                            textAlign: "center",
                            padding: "40px",
                            color: "#6c757d",
                          }}
                        >
                          Không có chi tiết kiểm kê
                        </div>
                      )}
                    </>
                  ) : null}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowDetailModal(false)}
                    aria-label="Đóng hộp thoại"
                    title="Đóng hộp thoại chi tiết"
                  >
                    Đóng
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  // Updated render selection section with proper accessibility

  // Updated render inventory table with search and filters
  const renderInventoryTable = () => {
    if (loading) {
      return (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <div
            className="spinner-border"
            role="status"
            aria-label="Đang tải dữ liệu"
          >
            <span className="sr-only">Đang tải...</span>
          </div>
        </div>
      );
    }

    if (inventory.length === 0 && viewMode === "create") {
      return (
        <div style={{ textAlign: "center", padding: "40px", color: "#6c757d" }}>
          <FiPackage
            size={48}
            style={{ marginBottom: "1rem", opacity: 0.5 }}
            aria-hidden="true"
          />
          <div>
            {selectedStore && selectedDate
              ? "Không có dữ liệu tồn kho cho cửa hàng và ngày đã chọn"
              : "Vui lòng chọn cửa hàng và ngày để tải dữ liệu tồn kho"}
          </div>
        </div>
      );
    }

    if (inventory.length > 0) {
      const { filteredInventory, filteredGrouped } =
        getFilteredGroupedInventory();
      const availableCategories = getAvailableCategories();
      const totals = filteredInventory.reduce(
        (acc, item) => {
          acc.totalDifference += Math.abs(item.ChenhLech || 0);
          acc.totalAmount += Math.abs(item.ThanhTienChenhLech || 0);
          return acc;
        },
        { totalDifference: 0, totalAmount: 0 }
      );

      return (
        <div
          className="table-responsive"
          role="region"
          aria-label="Bảng chi tiết kiểm kê tồn kho"
        >
          {/* Search and Filter Controls */}
          <div className="row mb-3 align-items-end">
            <div className="col-md-4">
              <label htmlFor="search-input" className="form-label">
                Tìm kiếm sản phẩm:
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  <FiSearch aria-hidden="true" />
                </span>
                <input
                  id="search-input"
                  type="text"
                  className="form-control"
                  placeholder="Nhập mã SP hoặc tên sản phẩm..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  aria-label="Tìm kiếm theo mã sản phẩm hoặc tên sản phẩm"
                  title="Tìm kiếm theo mã sản phẩm hoặc tên sản phẩm"
                />
              </div>
            </div>

            <div className="col-md-3">
              <label htmlFor="category-filter" className="form-label">
                Lọc theo nhóm:
              </label>
              <select
                id="category-filter"
                className="form-control"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                aria-label="Lọc theo nhóm sản phẩm"
                title="Lọc theo nhóm sản phẩm"
              >
                <option value="">-- Tất cả nhóm --</option>
                {Object.entries(availableCategories).map(
                  ([categoryId, categoryName]) => (
                    <option key={categoryId} value={categoryId}>
                      {categoryName}
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="col-md-3">
              <label htmlFor="stock-filter" className="form-label">
                Lọc theo tồn kho:
              </label>
              <select
                id="stock-filter"
                className="form-control"
                value={stockFilter}
                onChange={(e) => setStockFilter(e.target.value)}
                aria-label="Lọc theo trạng thái tồn kho"
                title="Lọc theo trạng thái tồn kho"
              >
                <option value="">-- Tất cả --</option>
                <option value="negative">Tồn âm (&lt; 0)</option>
                <option value="zero">Tồn bằng 0</option>
                <option value="positive">Tồn dương (&gt; 0)</option>
              </select>
            </div>

            <div className="col-md-2">
              <button
                type="button"
                className="btn btn-outline-secondary w-100"
                onClick={resetFilters}
                aria-label="Xóa bộ lọc"
                title="Xóa tất cả bộ lọc và tìm kiếm"
              >
                <FiX className="me-1" aria-hidden="true" />
                Xóa lọc
              </button>
            </div>
          </div>

          {/* Filter Results Info */}
          <div className="mb-3">
            <div
              className="alert alert-info d-flex align-items-center"
              role="status"
            >
              <FiBarChart2 className="me-2" aria-hidden="true" />
              <span>
                Hiển thị <strong>{filteredInventory.length}</strong> sản phẩm
                {(searchTerm || selectedCategory || stockFilter) && (
                  <span> / tổng {inventory.length} sản phẩm</span>
                )}
                {(searchTerm || selectedCategory || stockFilter) && (
                  <span className="ms-2">
                    {searchTerm && (
                      <span className="badge bg-primary me-1">
                        Tìm kiếm: "{searchTerm}"
                      </span>
                    )}
                    {selectedCategory && (
                      <span className="badge bg-success me-1">
                        Nhóm: {availableCategories[selectedCategory]}
                      </span>
                    )}
                    {stockFilter && (
                      <span className="badge bg-warning">
                        Tồn kho:{" "}
                        {stockFilter === "negative"
                          ? "Âm"
                          : stockFilter === "zero"
                            ? "Bằng 0"
                            : "Dương"}
                      </span>
                    )}
                  </span>
                )}
              </span>
            </div>
          </div>

          {filteredInventory.length === 0 ? (
            <div
              style={{ textAlign: "center", padding: "40px", color: "#6c757d" }}
            >
              <FiSearch
                size={48}
                style={{ marginBottom: "1rem", opacity: 0.5 }}
                aria-hidden="true"
              />
              <div>Không tìm thấy sản phẩm nào phù hợp với điều kiện lọc</div>
              <button
                type="button"
                className="btn btn-outline-primary mt-2"
                onClick={resetFilters}
                aria-label="Xóa bộ lọc để xem tất cả sản phẩm"
              >
                Xóa bộ lọc
              </button>
            </div>
          ) : (
            <>
              {Object.keys(filteredGrouped).length > 0 ? (
                // Render filtered grouped inventory
                Object.keys(filteredGrouped).map((categoryId) => {
                  const group = filteredGrouped[categoryId];
                  return (
                    <div key={categoryId} className="category-group mb-4">
                      <h5
                        className="category-header"
                        style={{
                          backgroundColor: "#f8f9fa",
                          padding: "10px 15px",
                          borderRadius: "5px",
                          marginBottom: "10px",
                          fontWeight: "600",
                          color: "#495057",
                          borderLeft: "5px solid #007bff",
                        }}
                        id={`category-${categoryId}`}
                        role="heading"
                        aria-level="3"
                      >
                        {group.name}
                        <span
                          className="badge bg-secondary ms-2"
                          style={{
                            fontSize: "0.7rem",
                            verticalAlign: "middle",
                          }}
                        >
                          {group.items.length} sản phẩm
                        </span>
                      </h5>

                      <table
                        className="table table-striped"
                        role="table"
                        aria-labelledby={`category-${categoryId}`}
                        aria-describedby={`category-${categoryId}-desc`}
                      >
                        <caption
                          id={`category-${categoryId}-desc`}
                          className="sr-only"
                        >
                          Bảng kiểm kê cho nhóm {group.name} với{" "}
                          {group.items.length} sản phẩm
                        </caption>
                        <thead>
                          <tr role="row">
                            <th scope="col">Mã SP</th>
                            <th scope="col">Tên sản phẩm</th>
                            <th scope="col" style={{ textAlign: "center" }}>
                              ĐVT
                            </th>
                            <th scope="col" style={{ textAlign: "right" }}>
                              Đơn giá
                            </th>
                            <th scope="col" style={{ textAlign: "right" }}>
                              Tồn sổ sách
                            </th>
                            <th scope="col" style={{ textAlign: "right" }}>
                              Tồn thực tế
                            </th>
                            <th scope="col" style={{ textAlign: "right" }}>
                              Chênh lệch
                            </th>
                            <th scope="col" style={{ textAlign: "right" }}>
                              Thành tiền CL
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {group.items.map((item, idx) => {
                            // Highlight search terms
                            const highlightText = (text, search) => {
                              if (!search) return text;
                              const regex = new RegExp(
                                `(${search.replace(
                                  /[.*+?^${}()|[\]\\]/g,
                                  "\\$&"
                                )})`,
                                "gi"
                              );
                              const parts = text.split(regex);
                              return parts.map((part, i) =>
                                regex.test(part) ? (
                                  <mark
                                    key={i}
                                    style={{
                                      backgroundColor: "#fff3cd",
                                      padding: "0 2px",
                                    }}
                                  >
                                    {part}
                                  </mark>
                                ) : (
                                  part
                                )
                              );
                            };

                            return (
                              <tr key={item.MaSP || idx} role="row">
                                <td style={{ fontWeight: "600" }}>
                                  {searchTerm
                                    ? highlightText(item.MaSP, searchTerm)
                                    : item.MaSP}
                                </td>
                                <td>
                                  {searchTerm
                                    ? highlightText(item.TenSP, searchTerm)
                                    : item.TenSP}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.DonViTinh}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {item.DonGia.toLocaleString("vi-VN")} ₫
                                </td>
                                <td
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "600",
                                    color:
                                      item.TonSoSach < 0
                                        ? "#ef4444"
                                        : item.TonSoSach === 0
                                          ? "#f59e0b"
                                          : "#10b981",
                                  }}
                                >
                                  {item.TonSoSach}
                                </td>
                                <td>
                                  <label
                                    htmlFor={`quantity-${item.MaSP}`}
                                    className="sr-only"
                                  >
                                    Tồn thực tế cho {item.TenSP}
                                  </label>
                                  <input
                                    id={`quantity-${item.MaSP}`}
                                    type="number"
                                    step="0.01"
                                    value={item.TonThucTe}
                                    onWheel={handleActualStockInputWheel}
                                    onKeyDown={handleActualStockInputKeyDown}
                                    onChange={(e) =>
                                      handleQuantityChange(
                                        item.MaSP,
                                        e.target.value
                                      )
                                    }
                                    className="form-control actual-stock-input"
                                    style={{
                                      textAlign: "right",
                                      appearance: "textfield",
                                      WebkitAppearance: "none",
                                      MozAppearance: "textfield",
                                    }}
                                    min="0"
                                    disabled={viewMode === "view"}
                                    aria-label={`Nhập số lượng tồn thực tế cho ${item.TenSP}`}
                                    title={`Nhập số lượng tồn thực tế cho ${item.TenSP}`}
                                    placeholder="Nhập số lượng"
                                  />
                                </td>
                                <td
                                  style={{
                                    textAlign: "right",
                                    color:
                                      item.ChenhLech > 0
                                        ? "#10b981"
                                        : item.ChenhLech < 0
                                          ? "#ef4444"
                                          : "#6b7280",
                                    fontWeight: "600",
                                  }}
                                >
                                  {item.ChenhLech > 0 ? "+" : ""}
                                  {item.ChenhLech}
                                </td>
                                <td
                                  style={{
                                    textAlign: "right",
                                    color:
                                      item.ThanhTienChenhLech > 0
                                        ? "#10b981"
                                        : item.ThanhTienChenhLech < 0
                                          ? "#ef4444"
                                          : "#6b7280",
                                    fontWeight: "600",
                                  }}
                                >
                                  {item.ThanhTienChenhLech > 0 ? "+" : ""}
                                  {item.ThanhTienChenhLech.toLocaleString(
                                    "vi-VN"
                                  )}{" "}
                                  ₫
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr
                            style={{
                              backgroundColor: "#f8f9fa",
                              fontWeight: "bold",
                            }}
                            role="row"
                          >
                            <td colSpan="4" className="text-end">
                              Tổng nhóm {group.name}:
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {group.items
                                .reduce(
                                  (sum, item) => sum + (item.TonSoSach || 0),
                                  0
                                )
                                .toLocaleString("vi-VN")}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {group.items
                                .reduce(
                                  (sum, item) => sum + (item.TonThucTe || 0),
                                  0
                                )
                                .toLocaleString("vi-VN")}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {group.items
                                .reduce(
                                  (sum, item) =>
                                    sum + Math.abs(item.ChenhLech || 0),
                                  0
                                )
                                .toFixed(2)}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {group.items
                                .reduce(
                                  (sum, item) =>
                                    sum +
                                    Math.abs(item.ThanhTienChenhLech || 0),
                                  0
                                )
                                .toLocaleString("vi-VN")}{" "}
                              ₫
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  );
                })
              ) : (
                // Render filtered ungrouped inventory as fallback
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Mã SP</th>
                      <th>Tên sản phẩm</th>
                      <th style={{ textAlign: "center" }}>ĐVT</th>
                      <th style={{ textAlign: "right" }}>Đơn giá</th>
                      <th style={{ textAlign: "right" }}>Tồn sổ sách</th>
                      <th style={{ textAlign: "right" }}>Tồn thực tế</th>
                      <th style={{ textAlign: "right" }}>Chênh lệch</th>
                      <th style={{ textAlign: "right" }}>Thành tiền CL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredInventory.map((item, index) => {
                      const highlightText = (text, search) => {
                        if (!search) return text;
                        const regex = new RegExp(
                          `(${search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
                          "gi"
                        );
                        const parts = text.split(regex);
                        return parts.map((part, i) =>
                          regex.test(part) ? (
                            <mark
                              key={i}
                              style={{
                                backgroundColor: "#fff3cd",
                                padding: "0 2px",
                              }}
                            >
                              {part}
                            </mark>
                          ) : (
                            part
                          )
                        );
                      };

                      return (
                        <tr key={item.MaSP || index}>
                          <td style={{ fontWeight: "600" }}>
                            {searchTerm
                              ? highlightText(item.MaSP, searchTerm)
                              : item.MaSP}
                          </td>
                          <td>
                            {searchTerm
                              ? highlightText(item.TenSP, searchTerm)
                              : item.TenSP}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.DonViTinh}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {item.DonGia.toLocaleString("vi-VN")} ₫
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              fontWeight: "600",
                              color:
                                item.TonSoSach < 0
                                  ? "#ef4444"
                                  : item.TonSoSach === 0
                                    ? "#f59e0b"
                                    : "#10b981",
                            }}
                          >
                            {item.TonSoSach}
                          </td>
                          <td>
                            <input
                              type="number"
                              step="0.01"
                              value={item.TonThucTe}
                              onWheel={handleActualStockInputWheel}
                              onKeyDown={handleActualStockInputKeyDown}
                              onChange={(e) =>
                                handleQuantityChange(item.MaSP, e.target.value)
                              }
                              className="form-control actual-stock-input"
                              style={{
                                textAlign: "right",
                                appearance: "textfield",
                                WebkitAppearance: "none",
                                MozAppearance: "textfield",
                              }}
                              min="0"
                              disabled={viewMode === "view"}
                            />
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              color:
                                item.ChenhLech > 0
                                  ? "#10b981"
                                  : item.ChenhLech < 0
                                    ? "#ef4444"
                                    : "#6b7280",
                              fontWeight: "600",
                            }}
                          >
                            {item.ChenhLech > 0 ? "+" : ""}
                            {item.ChenhLech}
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              color:
                                item.ThanhTienChenhLech > 0
                                  ? "#10b981"
                                  : item.ThanhTienChenhLech < 0
                                    ? "#ef4444"
                                    : "#6b7280",
                              fontWeight: "600",
                            }}
                          >
                            {item.ThanhTienChenhLech > 0 ? "+" : ""}
                            {item.ThanhTienChenhLech.toLocaleString("vi-VN")} ₫
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr
                      style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}
                      role="row"
                    >
                      <td colSpan="6" style={{ textAlign: "right" }}>
                        Tổng cộng (đã lọc):
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {totals.totalDifference.toFixed(2)}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {totals.totalAmount.toLocaleString("vi-VN")} ₫
                      </td>
                    </tr>
                  </tfoot>
                </table>
              )}

              {/* Grand total for filtered results */}
              <table
                className="table"
                role="table"
                aria-label="Tổng cộng kết quả đã lọc"
              >
                <caption className="sr-only">
                  Bảng tổng cộng chênh lệch của kết quả đã lọc
                </caption>
                <tfoot>
                  <tr
                    style={{
                      backgroundColor: "#e3f2fd",
                      fontWeight: "bold",
                      border: "2px solid #1976d2",
                    }}
                    role="row"
                  >
                    <td
                      colSpan="6"
                      style={{ textAlign: "right", color: "#1976d2" }}
                    >
                      TỔNG CỘNG KẾT QUẢ LỌC ({filteredInventory.length} sản
                      phẩm):
                    </td>
                    <td style={{ textAlign: "right", color: "#1976d2" }}>
                      {totals.totalDifference.toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", color: "#1976d2" }}>
                      {totals.totalAmount.toLocaleString("vi-VN")} ₫
                    </td>
                  </tr>
                </tfoot>
              </table>
            </>
          )}
        </div>
      );
    }

    return null;
  };

  // Updated render detail modal to show grouped data
  const renderDetailModal = () => {
    if (!showDetailModal) return null;

    return (
      <div
        className="modal"
        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Chi tiết phiếu kiểm kê #{selectedRecordDetail?.IDPhieu}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowDetailModal(false)}
                aria-label="Đóng hộp thoại"
                title="Đóng hộp thoại chi tiết"
              ></button>
            </div>
            <div className="modal-body">
              {detailLoading ? (
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Đang tải...</span>
                  </div>
                </div>
              ) : selectedRecordDetail ? (
                <>
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <strong>Ngày kiểm kê:</strong>
                      <br />
                      {new Date(
                        selectedRecordDetail.NgayKiemKe
                      ).toLocaleDateString("vi-VN")}
                    </div>
                    <div className="col-md-3">
                      <strong>Người kiểm kê:</strong>
                      <br />
                      {selectedRecordDetail.TenUser}
                    </div>
                    <div className="col-md-6">
                      <strong>Ghi chú:</strong>
                      <br />
                      {selectedRecordDetail.GhiChu || "Không có"}
                    </div>
                  </div>

                  {selectedRecordDetail.ChiTiet &&
                    selectedRecordDetail.ChiTiet.length > 0 ? (
                    <div>
                      {selectedRecordDetail.GroupedChiTiet ? (
                        // Render grouped details
                        Object.keys(selectedRecordDetail.GroupedChiTiet).map(
                          (categoryId) => {
                            const group =
                              selectedRecordDetail.GroupedChiTiet[categoryId];
                            return (
                              <div
                                key={categoryId}
                                className="category-group mb-4"
                              >
                                <h5
                                  className="category-header"
                                  style={{
                                    backgroundColor: "#f8f9fa",
                                    padding: "10px 15px",
                                    borderRadius: "5px",
                                    marginBottom: "10px",
                                    fontWeight: "600",
                                    color: "#495057",
                                    borderLeft: "5px solid #007bff",
                                  }}
                                >
                                  {group.name}
                                  <span
                                    className="badge bg-secondary ms-2"
                                    style={{
                                      fontSize: "0.7rem",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    {group.items.length} sản phẩm
                                  </span>
                                </h5>

                                <div className="table-responsive">
                                  <table className="table table-striped table-sm">
                                    <thead>
                                      <tr>
                                        <th>STT</th>
                                        <th>Mã SP</th>
                                        <th>Tên sản phẩm</th>
                                        <th style={{ textAlign: "center" }}>
                                          ĐVT
                                        </th>
                                        <th style={{ textAlign: "right" }}>
                                          Đơn giá
                                        </th>
                                        <th style={{ textAlign: "right" }}>
                                          Tồn sổ sách
                                        </th>
                                        <th style={{ textAlign: "right" }}>
                                          Tồn thực tế
                                        </th>
                                        <th style={{ textAlign: "right" }}>
                                          Chênh lệch
                                        </th>
                                        <th style={{ textAlign: "right" }}>
                                          Thành tiền CL
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {group.items.map((item, idx) => (
                                        <tr key={item.IDChiTiet || idx}>
                                          <td>{idx + 1}</td>
                                          <td>
                                            <strong>{item.MaSP}</strong>
                                          </td>
                                          <td>{item.TenSP}</td>
                                          <td style={{ textAlign: "center" }}>
                                            {item.DonViTinh}
                                          </td>
                                          <td style={{ textAlign: "right" }}>
                                            {item.DonGia.toLocaleString(
                                              "vi-VN"
                                            )}{" "}
                                            ₫
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "right",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {item.TonSoSach}
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "right",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {item.TonThucTe}
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "right",
                                              color:
                                                (item.ChenhLech || 0) > 0
                                                  ? "#10b981"
                                                  : (item.ChenhLech || 0) < 0
                                                    ? "#ef4444"
                                                    : "#6b7280",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {(item.ChenhLech || 0) > 0
                                              ? "+"
                                              : ""}
                                            {item.ChenhLech || 0}
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "right",
                                              color:
                                                (item.ThanhTienChenhLech || 0) >
                                                  0
                                                  ? "#10b981"
                                                  : (item.ThanhTienChenhLech || 0) < 0
                                                    ? "#ef4444"
                                                    : "#6b7280",
                                              fontWeight: "600",
                                            }}
                                          >
                                            {(item.ThanhTienChenhLech || 0) > 0
                                              ? "+"
                                              : ""}
                                            {(
                                              item.ThanhTienChenhLech || 0
                                            ).toLocaleString("vi-VN")}{" "}
                                            ₫
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                    <tfoot>
                                      <tr
                                        style={{
                                          backgroundColor: "#f0f8ff",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <td
                                          colSpan="5"
                                          style={{ textAlign: "right" }}
                                        >
                                          Tổng nhóm {group.name}:
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {group.items
                                            .reduce(
                                              (sum, item) =>
                                                sum + (item.TonSoSach || 0),
                                              0
                                            )
                                            .toLocaleString("vi-VN")}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {group.items
                                            .reduce(
                                              (sum, item) =>
                                                sum + (item.TonThucTe || 0),
                                              0
                                            )
                                            .toLocaleString("vi-VN")}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {group.items
                                            .reduce(
                                              (sum, item) =>
                                                sum +
                                                Math.abs(item.ChenhLech || 0),
                                              0
                                            )
                                            .toFixed(2)}
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {group.items
                                            .reduce(
                                              (sum, item) =>
                                                sum +
                                                Math.abs(
                                                  item.ThanhTienChenhLech || 0
                                                ),
                                              0
                                            )
                                            .toLocaleString("vi-VN")}{" "}
                                          ₫
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            );
                          }
                        )
                      ) : (
                        // Render ungrouped details as fallback
                        <div className="table-responsive">
                          <table className="table table-striped table-sm">
                            <thead>
                              <tr>
                                <th>STT</th>
                                <th>Mã SP</th>
                                <th>Tên sản phẩm</th>
                                <th style={{ textAlign: "center" }}>ĐVT</th>
                                <th style={{ textAlign: "right" }}>Đơn giá</th>
                                <th style={{ textAlign: "right" }}>
                                  Tồn sổ sách
                                </th>
                                <th style={{ textAlign: "right" }}>
                                  Tồn thực tế
                                </th>
                                <th style={{ textAlign: "right" }}>
                                  Chênh lệch
                                </th>
                                <th style={{ textAlign: "right" }}>
                                  Thành tiền CL
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {selectedRecordDetail.ChiTiet.map(
                                (item, index) => (
                                  <tr key={item.IDChiTiet || index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <strong>{item.MaSP}</strong>
                                    </td>
                                    <td>{item.TenSP}</td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.DonViTinh}
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                      {item.DonGia.toLocaleString("vi-VN")} ₫
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "right",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {item.TonSoSach}
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "right",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {item.TonThucTe}
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "right",
                                        color:
                                          (item.ChenhLech || 0) > 0
                                            ? "#10b981"
                                            : (item.ChenhLech || 0) < 0
                                              ? "#ef4444"
                                              : "#6b7280",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {(item.ChenhLech || 0) > 0 ? "+" : ""}
                                      {item.ChenhLech || 0}
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "right",
                                        color:
                                          (item.ThanhTienChenhLech || 0) > 0
                                            ? "#10b981"
                                            : (item.ThanhTienChenhLech || 0) < 0
                                              ? "#ef4444"
                                              : "#6b7280",
                                        fontWeight: "600",
                                      }}
                                    >
                                      {(item.ThanhTienChenhLech || 0) > 0
                                        ? "+"
                                        : ""}
                                      {(
                                        item.ThanhTienChenhLech || 0
                                      ).toLocaleString("vi-VN")}{" "}
                                      ₫
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                            <tfoot>
                              <tr
                                style={{
                                  backgroundColor: "#f8f9fa",
                                  fontWeight: "bold",
                                }}
                              >
                                <td colSpan="7" style={{ textAlign: "right" }}>
                                  Tổng cộng:
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {selectedRecordDetail.ChiTiet.reduce(
                                    (sum, item) =>
                                      sum + Math.abs(item.ChenhLech || 0),
                                    0
                                  ).toFixed(2)}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {selectedRecordDetail.ChiTiet.reduce(
                                    (sum, item) =>
                                      sum +
                                      Math.abs(item.ThanhTienChenhLech || 0),
                                    0
                                  ).toLocaleString("vi-VN")}{" "}
                                  ₫
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      )}

                      {/* Grand total */}
                      <table className="table">
                        <tfoot>
                          <tr
                            style={{
                              backgroundColor: "#f8f9fa",
                              fontWeight: "bold",
                            }}
                          >
                            <td colSpan="7" style={{ textAlign: "right" }}>
                              TỔNG CỘNG TẤT CẢ:
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {selectedRecordDetail.ChiTiet.reduce(
                                (sum, item) =>
                                  sum + Math.abs(item.ChenhLech || 0),
                                0
                              ).toFixed(2)}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {selectedRecordDetail.ChiTiet.reduce(
                                (sum, item) =>
                                  sum + Math.abs(item.ThanhTienChenhLech || 0),
                                0
                              ).toLocaleString("vi-VN")}{" "}
                              ₫
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#6c757d",
                      }}
                    >
                      Không có chi tiết kiểm kê
                    </div>
                  )}
                </>
              ) : null}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowDetailModal(false)}
                aria-label="Đóng hộp thoại"
                title="Đóng hộp thoại chi tiết"
              >
                Đóng
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderFormView = () => (
    <div className="admin-layout">
      <div className="admin-main" style={{ marginLeft: 0 }}>
        <header className="admin-header">
          <div className="header-left">
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <FiClipboard size={32} color="#495057" aria-hidden="true" />
              <div>
                <h1>
                  {viewMode === "view"
                    ? "Xem phiếu kiểm kê"
                    : viewMode === "edit"
                      ? "Chỉnh sửa phiếu kiểm kê"
                      : "Tạo phiếu kiểm kê mới"}
                </h1>
                <p>
                  {viewMode === "view"
                    ? "Xem chi tiết phiếu kiểm kê"
                    : viewMode === "edit"
                      ? "Chỉnh sửa thông tin phiếu kiểm kê"
                      : "Tạo phiếu kiểm kê cho cửa hàng"}
                </p>
              </div>
            </div>
          </div>
          <div className="header-right">
            <button
              type="button"
              className="btn btn-outline-secondary me-2"
              onClick={showListView}
              aria-label="Quay lại danh sách phiếu kiểm kê"
              title="Quay lại danh sách phiếu kiểm kê"
            >
              <FiList className="me-1" aria-hidden="true" />
              Danh sách phiếu
            </button>
            {viewMode === "view" && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleEditRecord(selectedRecord)}
                aria-label="Chuyển sang chế độ chỉnh sửa"
                title="Chuyển sang chế độ chỉnh sửa phiếu kiểm kê này"
              >
                <FiEdit3 className="me-1" aria-hidden="true" />
                Chỉnh sửa
              </button>
            )}
            {viewMode === "edit" && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={updateRecord}
                disabled={submitting}
                aria-label={
                  submitting
                    ? "Đang cập nhật phiếu kiểm kê"
                    : "Cập nhật phiếu kiểm kê"
                }
                title={
                  submitting
                    ? "Đang cập nhật phiếu kiểm kê"
                    : "Lưu các thay đổi"
                }
              >
                <FiSave className="me-1" aria-hidden="true" />
                {submitting ? "Đang lưu..." : "Cập nhật"}
              </button>
            )}
            {viewMode === "create" && (
              <button
                type="submit"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={
                  submitting || inventory.length === 0 || !selectedStore
                }
                aria-label={
                  submitting
                    ? "Đang lưu phiếu kiểm kê"
                    : "Lưu phiếu kiểm kê mới"
                }
                title={
                  submitting
                    ? "Đang lưu phiếu kiểm kê"
                    : "Lưu phiếu kiểm kê mới"
                }
              >
                <FiSave className="me-1" aria-hidden="true" />
                {submitting ? "Đang lưu..." : "Lưu phiếu kiểm kê"}
              </button>
            )}
          </div>
        </header>

        {message && (
          <div className="content-section">
            <div
              className={`alert ${message.includes("thành công")
                  ? "alert-success"
                  : "alert-danger"
                }`}
              role="alert"
              aria-live="polite"
            >
              {message}
            </div>
          </div>
        )}

        {/* Import message */}
        {importMessage && (
          <div className="content-section">
            <div
              className={`alert ${importMessage.includes("thành công")
                  ? "alert-success"
                  : "alert-warning"
                }`}
              role="alert"
              aria-live="polite"
            >
              {importMessage}
            </div>
          </div>
        )}

        {/* Store and Date Selection */}
        {viewMode === "create" && renderSelectionSection()}

        {/* Header Information */}
        <div className="content-section">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">Thông tin phiếu kiểm kê</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <label htmlFor="ngay-kiem-ke" className="form-label">
                    Ngày kiểm kê:
                  </label>
                  <input
                    id="ngay-kiem-ke"
                    type="date"
                    className="form-control"
                    value={formData.NgayKiemKe}
                    onChange={handleDateChange}
                    required
                    disabled={viewMode === "view"}
                    aria-label="Chọn ngày thực hiện kiểm kê"
                    title="Chọn ngày thực hiện kiểm kê"
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="ten-user" className="form-label">
                    Người kiểm kê:
                  </label>
                  <input
                    id="ten-user"
                    type="text"
                    className="form-control"
                    value={formData.TenUser}
                    onChange={(e) =>
                      handleFormChange("TenUser", e.target.value)
                    }
                    placeholder="Nhập tên người kiểm kê"
                    required
                    disabled={viewMode === "view"}
                    aria-label="Nhập tên người thực hiện kiểm kê"
                    title="Nhập tên người thực hiện kiểm kê"
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="ghi-chu" className="form-label">
                    Ghi chú:
                  </label>
                  <textarea
                    id="ghi-chu"
                    className="form-control"
                    value={formData.GhiChu}
                    onChange={(e) => handleFormChange("GhiChu", e.target.value)}
                    placeholder="Ghi chú (tùy chọn)"
                    rows={1}
                    disabled={viewMode === "view"}
                    aria-label="Nhập ghi chú cho phiếu kiểm kê"
                    title="Nhập ghi chú bổ sung cho phiếu kiểm kê"
                  />
                </div>
              </div>

              {selectedStore && (
                <div
                  className="alert alert-info mt-3"
                  role="status"
                  aria-live="polite"
                >
                  <strong>Cửa hàng:</strong>{" "}
                  {stores.find((s) => s.IDCH === selectedStore)?.TenCuaHang ||
                    selectedStore}{" "}
                  |<strong> Ngày kiểm kê:</strong>{" "}
                  {new Date(selectedDate).toLocaleDateString("vi-VN")}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Inventory Table */}
        <div className="content-section">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Chi tiết kiểm kê</h5>
              <div className="d-flex gap-2">
                {/* Import Excel buttons - only show in create/edit mode */}
                {(viewMode === "create" || viewMode === "edit") &&
                  inventory.length > 0 && (
                    <>
                      <button
                        type="button"
                        className="btn btn-outline-warning btn-sm"
                        onClick={handleSetAllActualStockZero}
                        disabled={submitting}
                        aria-label="Cập nhật tồn thực tế toàn bộ sản phẩm thành 0"
                        title="Điền số tồn thực tế của toàn bộ sản phẩm thành 0"
                      >
                        <FiEdit3 className="me-1" aria-hidden="true" />
                        Cập nhật tồn 0
                      </button>

                      <button
                        type="button"
                        className="btn btn-outline-success btn-sm"
                        onClick={exportTemplateExcel}
                        aria-label="Tải template Excel"
                        title="Tải file template Excel để import số lượng"
                      >
                        <FiDownload className="me-1" aria-hidden="true" />
                        Tải template
                      </button>

                      <label
                        className="btn btn-outline-primary btn-sm mb-0"
                        style={{ cursor: "pointer" }}
                        aria-label="Import file Excel"
                        title="Import số lượng từ file Excel"
                      >
                        <FiUpload className="me-1" aria-hidden="true" />
                        {importLoading ? "Đang import..." : "Import Excel"}
                        <input
                          type="file"
                          accept=".xlsx,.xls"
                          onChange={importExcelData}
                          style={{ display: "none" }}
                          disabled={importLoading}
                        />
                      </label>
                    </>
                  )}

                {viewMode === "create" && selectedStore && selectedDate && (
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={() =>
                      fetchInventoryData(selectedStore, selectedDate)
                    }
                    disabled={loading}
                    aria-label={
                      loading
                        ? "Đang tải lại dữ liệu"
                        : "Tải lại dữ liệu tồn kho"
                    }
                    title={
                      loading
                        ? "Đang tải lại dữ liệu"
                        : "Tải lại dữ liệu tồn kho từ hệ thống"
                    }
                  >
                    <FiRefreshCw
                      className={loading ? "spinning me-1" : "me-1"}
                      aria-hidden="true"
                    />
                    {loading ? "Đang tải..." : "Tải lại dữ liệu"}
                  </button>
                )}
              </div>
            </div>
            <div className="card-body">{renderInventoryTable()}</div>
          </div>
        </div>
      </div>

      {/* Detail Modal */}
      {renderDetailModal()}
    </div>
  );

  // Handle store selection
  const handleStoreChange = (event) => {
    const storeId = event.target.value;
    setSelectedStore(storeId);
  };

  // Handle date selection
  const handleDateChange = (event) => {
    const date = event.target.value;
    setSelectedDate(date);
    setFormData((prev) => ({
      ...prev,
      NgayKiemKe: date,
    }));
  };

  // Add import Excel function
  const importExcelData = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImportLoading(true);
    setImportMessage('');

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: 'buffer', cellText: false, cellDates: true });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Đọc tất cả dữ liệu dưới dạng raw values (không ép kiểu tự động)
      const rawData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: '',
        blankrows: true,
        raw: false  // Giữ nguyên giá trị gốc (rất quan trọng để đọc đúng số thập phân dạng text)
      });

      if (rawData.length === 0) {
        setImportMessage('File Excel không có dữ liệu');
        return;
      }

      let processedData = [];
      let dataStartRow = 5; // Mặc định bắt đầu từ dòng 6 (index 5)

      // Tìm dòng header chính xác (có "Mã hàng" và "Số lượng")
      for (let i = 0; i < rawData.length; i++) {
        const row = rawData[i];
        const cellA = row[0] ? String(row[0]).trim() : '';
        const cellC = row[2] ? String(row[2]).trim() : '';

        if (cellA === 'Mã hàng' && cellC === 'Số lượng') {
          dataStartRow = i + 1;
          break;
        }
      }

      // Hàm chuyển đổi số an toàn (hỗ trợ cả dấu chấm và dấu phẩy)
      const parseNumber = (value) => {
        if (value === null || value === undefined || value === '') return null;

        let str = String(value).trim();

        // Thay dấu phẩy thành dấu chấm (hỗ trợ người dùng nhập 0,5)
        str = str.replace(/,/g, '.');

        // Loại bỏ các ký tự không phải số, dấu chấm, dấu trừ
        str = str.replace(/[^\d.-]/g, '');

        // Nếu là chuỗi số hợp lệ
        if (/^-?\d*\.?\d*$/.test(str) && str !== '' && str !== '-' && str !== '.') {
          const num = parseFloat(str);
          return isNaN(num) ? null : num;
        }
        return null;
      };

      // Xử lý từng dòng từ dataStartRow trở đi
      for (let i = dataStartRow; i < rawData.length; i++) {
        const row = rawData[i];
        if (!row || row.length < 3) continue;

        const maSPRaw = row[0];
        const soLuongRaw = row[2]; // Cột C = Số lượng

        // Bỏ qua dòng trống
        if (!maSPRaw && !soLuongRaw) continue;

        const maSP = String(maSPRaw || '').trim();
        if (!maSP) continue;

        // Bỏ qua dòng tiêu đề, mẫu
        if (maSP.toLowerCase().includes('mã hàng') ||
          maSP.toLowerCase().includes('template') ||
          maSP.toLowerCase().includes('sample')) continue;

        const soLuong = parseNumber(soLuongRaw);

        // Nếu không parse được số lượng → bỏ qua dòng (hoặc có thể gán 0 tùy yêu cầu)
        if (soLuong === null) {
          console.warn(`Không đọc được số lượng tại dòng ${i + 1}:`, soLuongRaw);
          continue; // hoặc: soLuong = 0;
        }

        processedData.push({
          'Mã hàng': maSP,
          'Số lượng': soLuong,
          'Tên sản phẩm': row[1] ? String(row[1]).trim() : null
        });
      }

      if (processedData.length === 0) {
        setImportMessage('Không tìm thấy dữ liệu hợp lệ để import. Vui lòng kiểm tra lại file.');
        return;
      }

      // === CẬP NHẬT TỒN KHO ===
      let importCount = 0;
      let addedCount = 0;
      const updatedInventory = [...inventory];
      const addedItems = [];

      processedData.forEach(item => {
        const maSP = item['Mã hàng'];
        const soLuong = item['Số lượng']; // Đã là số thập phân chính xác

        const idx = updatedInventory.findIndex(
          inv => inv.MaSP && inv.MaSP.toString().trim().toUpperCase() === maSP.toUpperCase()
        );

        if (idx !== -1) {
          const invItem = updatedInventory[idx];
          invItem.TonThucTe = soLuong;
          invItem.ChenhLech = soLuong - invItem.TonSoSach;
          invItem.ThanhTienChenhLech = invItem.ChenhLech * invItem.DonGia;
          importCount++;
        } else {
          updatedInventory.push({
            MaSP: maSP,
            TenSP: item['Tên sản phẩm'] || `Sản phẩm ${maSP}`,
            DonViTinh: 'Cái',
            DonGia: 0,
            TonSoSach: 0,
            TonThucTe: soLuong,
            ChenhLech: soLuong,
            ThanhTienChenhLech: 0,
            MaNLSP: null
          });
          addedItems.push(maSP);
          addedCount++;
        }
      });

      setInventory(updatedInventory);
      await groupInventoryByCategory(updatedInventory);

      setImportMessage(
        `Import thành công! Cập nhật ${importCount} sản phẩm, ` +
        `thêm mới ${addedCount} sản phẩm ` +
        (addedCount > 0 && addedCount <= 10 ? `(${addedItems.join(', ')})` : '')
      );

    } catch (error) {
      console.error('Lỗi import Excel:', error);
      setImportMessage('Lỗi khi đọc file: ' + error.message);
    } finally {
      setImportLoading(false);
      event.target.value = '';
    }
  };

  const exportTemplateExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Template Import");

      // Tiêu đề lớn
      worksheet.mergeCells("A1:D1");
      const titleCell = worksheet.getCell("A1");
      titleCell.value = "TEMPLATE IMPORT SỐ LƯỢNG KIỂM KÊ";
      titleCell.font = { size: 16, bold: true };
      titleCell.alignment = { horizontal: "center", vertical: "middle" };
      worksheet.getRow(1).height = 35;

      // Dòng trống
      worksheet.mergeCells("A2:D3");
      worksheet.getRow(2).height = 15;

      // Header
      const headerRow = worksheet.addRow([
        "Mã hàng",
        "Tên sản phẩm",
        "Số lượng",
        "Ghi chú",
      ]);
      headerRow.font = { bold: true };
      headerRow.alignment = { horizontal: "center" };
      headerRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE6E6FA" },
      };
      worksheet.getRow(4).height = 25;

      // Cột rộng
      worksheet.columns = [
        { width: 15 },
        { width: 35 },
        { width: 15 },
        { width: 40 },
      ];

      // Dòng trống
      worksheet.addRow([]);

      // Thêm dữ liệu tồn kho hiện tại
      inventory.forEach((item) => {
        worksheet.addRow([
          item.MaSP || "",
          item.TenSP || "",
          "", // Số lượng để trống cho người dùng nhập
          `Tồn sổ sách: ${Number(item.TonSoSach)
            .toFixed(4)
            .replace(/\.?0+$/, "")}`,
        ]);
      });

      // Style cho dòng dữ liệu
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber >= 6) {
          // Từ dòng dữ liệu đầu tiên
          row.alignment = { vertical: "middle", horizontal: "left" };
          row.getCell(3).alignment = { horizontal: "center" }; // Cột số lượng
        }
      });

      // Xuất file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Template_Import_KiemKe_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Lỗi export template:", error);
      alert("Lỗi khi tạo file template!");
    }
  };

  // Fetch inventory data on store or date change
  useEffect(() => {
    if (selectedStore && selectedDate) {
      fetchInventoryData(selectedStore, selectedDate);
    }
  }, [selectedStore, selectedDate]);

  // Fetch existing records on view mode change
  useEffect(() => {
    if (viewMode === "list") {
      fetchExistingRecords();
    }
  }, [viewMode]);

  // Fetch detailed records on detailed view
  useEffect(() => {
    if (showDetailModal && selectedRecordDetail) {
      fetchRecordDetails(selectedRecordDetail.IDPhieu);
    }
  }, [showDetailModal, selectedRecordDetail]);

  const totals = calculateTotals();

  return (
    <>
      {viewMode === "list" ? (
        renderListView()
      ) : (
        <form
          onSubmit={
            viewMode === "create" ? handleSubmit : (e) => e.preventDefault()
          }
        >
          {renderFormView()}
        </form>
      )}
    </>
  );
};

export default KiemKe;
